export interface RTKQMeta<OriginalArgs = unknown> {
    meta: {
        arg: {
            endpointName: string;
            originalArgs: OriginalArgs;
        };
        baseQueryMeta: {
            request: Request;
            response?: Response;
        };
    };
}

export const isRTKQMeta = <OriginalArgs = unknown>(action: any): action is RTKQMeta<OriginalArgs> =>
    action?.meta?.baseQueryMeta?.request instanceof Request;
